var exports = {
  "A": "x4ddf2309--65ca29--control",
};

module.exports = exports;
